// 27 unidades federativas brasileiras (26 estados + DF), ordem alfabética.
// Compartilhado por modais de cadastro de Imóvel e Área para o dropdown de UF.
export const UF_OPTIONS = [
  'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT',
  'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO',
];
